import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "categories", "logo", "url", "images", "address", "defaultType"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { DEFAULT_SEO_TYPE } from './LocalBusinessSchema.constants';
import { getFirstIfArray, getSchemaGeneratorFunction, getTypeForCategory } from './LocalBusinessSchema.utils';
import { Helmet } from '../../../../modules/foundation/components/HelmetProvider';
import { BusinessCategoriesPropType } from '../../../../modules/foundation/types/category';
import { ImagePropType, ImagesPropType, LocationPropType } from '../../../../services/proptypes';
var defaultProps = {
  url: null,
  images: [],
  logo: null,
  address: null,
  defaultType: DEFAULT_SEO_TYPE
};
export default function LocalBusinessSchema(_ref) {
  var name = _ref.name,
    categories = _ref.categories,
    logo = _ref.logo,
    url = _ref.url,
    images = _ref.images,
    address = _ref.address,
    defaultType = _ref.defaultType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _getFirstIfArray = getFirstIfArray(categories),
    category = _getFirstIfArray.category,
    subCategory = _getFirstIfArray.subCategory;
  var type = getTypeForCategory(category, {
    fallback: defaultType
  });
  var schemaGeneratorFunction = getSchemaGeneratorFunction(category);
  var schema = schemaGeneratorFunction(name, type, _objectSpread({
    url: url,
    images: images,
    logo: logo,
    address: address,
    subCategory: subCategory
  }, rest));
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
}
LocalBusinessSchema.defaultProps = defaultProps;